'use strict';

import Phase from './Phase';
import SunsetPhase from './SunsetPhase';
import GuardianPhase from './GuardianPhase';
import WerewolfPhase from './WerewolfPhase';
import WitchPhase from './WitchPhase';
import SeerPhase from './SeerPhase';
import SunrisePhase from './SunrisePhase';
import PollPhase from './PollPhase';
import IdiotPhase from './IdiotPhase';
import PollCountPhase from './PollCountPhase';

export default {
  Phase,
  EMPTY_PHASE: Phase.EMPTY,
  SunsetPhase,
  GuardianPhase,
  WerewolfPhase,
  WitchPhase,
  SeerPhase,
  SunrisePhase,
  PollPhase,
  IdiotPhase,
  PollCountPhase
};



/** WEBPACK FOOTER **
 ** ./scripts/models/phases/index.jsx
 **/